const ValueCard = ({ title, description }) => {
  return (
    <div className="p-8 bg-white border border-gray-300">
      <div className="flex items-center justify-center mb-6" style={{ minHeight: '80px' }}>
        <h3 className="text-xl md:text-2xl font-normal text-center" style={{ color: '#2f4c74' }}>
          {title}
        </h3>
      </div>
      <hr className="border-gray-300 mb-6" />
      <p className="text-base text-left leading-relaxed" style={{ color: '#2b3d57' }}>
        {description}
      </p>
    </div>
  );
};

export default ValueCard;
